export default __webpack_public_path__ + "static/investors-contact-adb13645dddbd771ac163be32b32a979.png";